import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatDivider } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { ThemeService } from '../../services/theme.service';
import { AppTitleService } from '../../services/app-title.service';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UtilService } from '../../services/util.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
    selector: 'app-init',
    imports: [
    UserMenuComponent,
    RouterLink,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatDivider,
    RouterOutlet,
    MatMenuModule,
    RouterLinkActive,
    MatExpansionModule,
    MatBadgeModule,
    MatTooltipModule
],
    templateUrl: './init.component.html',
    styleUrl: './init.component.scss'
})
export class InitComponent implements OnDestroy {
  title = localStorage.getItem("system-name");
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  panelOpenState = true;

  readonly logoConfigID = 501;
  logoPath?: SafeResourceUrl;

  /*Manejo de thema*/
  themeService: ThemeService = inject(ThemeService);
  titleService: AppTitleService = inject(AppTitleService);
  utilService: UtilService = inject(UtilService);
  constructor(        
    changeDetectorRef: ChangeDetectorRef,
    sanitizer: DomSanitizer,
    media: MediaMatcher
  ) {
    this.themeService.setTheme(this.themeService.themeSignal())
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.utilService.getConfigurationParameter(this.logoConfigID).subscribe({
      next: (response) => {
        this.logoPath = sanitizer.bypassSecurityTrustResourceUrl(response.texto);
      }
    });
    this.utilService.callTasks();
    //const token = authService.getTokenData();
    /*const userId = token ? token.id : null;
    if (!userId){
      console.warn("No se encontró userId en el token. No se iniciará la conexión SSE.");
    }
    sseClientServ.setUserId(userId||""); // Asignar el userId al servicio SSE

    // Conectar cuando la página cargue
    document.addEventListener('DOMContentLoaded', () => {
        sseClientServ.connect();
        console.log('conectado SSE');
    });

    // Desconectar cuando se cierre la página
    window.addEventListener('beforeunload', () => {
        sseClientServ.disconnect();
        console.log('Desconectando SSE');
    });*/

  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
